import FormBuilderWithLayout, { FormField } from '@/components/company/FormBuilderWithLayout';
import { UseFormReturn } from 'react-hook-form';
import { IJobDescription } from '@/states/job.state';

interface Props {
  formControl: UseFormReturn<IJobDescription>;
  onSubmit: () => void;
  onCancel: () => void;
}

export default function ReportForm({ formControl, onSubmit, onCancel }: Props) {
  const fields: FormField[] = [
    { name: 'org_chart_node.name', label: 'Role', type: 'text', disable: true },
    { name: 'org_key_activity.name', label: 'Key Activities', type: 'text', disable: true },
    { name: 'name', label: 'Job Description', type: 'text', disable: true, colSpan: 2 },
    { name: 'report', label: 'Report', type: 'text', required: true },
    { name: 'frequency', label: 'Frequency', type: 'text', required: true },
    {
      name: 'report_file',
      label: 'Upload Report Template',
      type: 'upload',
      uploadType: 'file',
      required: true,
      colSpan: 2,
    },
  ];

  return (
    <form onSubmit={onSubmit} className="mt-4">
      <FormBuilderWithLayout
        description="Edit Report Template"
        fields={fields}
        onSubmit={onSubmit}
        onCancel={onCancel}
        submitLabel="Update"
        cancelLabel="Cancel"
      />
    </form>
  );
}
